import Users from "api/lib/data/Users";
import * as React from "react";
import { connect } from "react-redux";
import { SESSION_EVENTS } from "src/reducers/session";
import { firebase } from "../../firebase";

interface IInterfaceProps {
  authUser?: any;
}

interface IInterfaceState {
  authUser?: any;
  userSettings?: any;
  queryIdOnCall?: string;
}

export const withAuthentication = (Component: any) => {
  class WithAuthentication extends React.Component<
    IInterfaceProps,
    IInterfaceState
  > {
    public componentDidMount() {
      const { onSetAuthUser }: any = this.props;

      firebase.auth.onAuthStateChanged((authUser: firebase.User) => {
        const user = new Users(authUser.uid);
        user
          .getSettings()
          .once("value", (snap: firebase.database.DataSnapshot) => {
            const userSettings = snap.val();
            authUser
              ? onSetAuthUser({ authUser, userSettings })
              : onSetAuthUser(null);
          });
      });
    }

    public render() {
      return <Component />;
    }
  }

  const mapDispatchToProps = (dispatch: any) => ({
    onSetAuthUser: (authUser: firebase.User) =>
      dispatch({ type: SESSION_EVENTS.AUTH_USER_SET, authUser }),
  });

  return connect(null, mapDispatchToProps)(WithAuthentication);
};



// WEBPACK FOOTER //
// ./src/components/Session/withAuthentication.tsx